module.exports = __webpack_public_path__ + "static/media/food.ef56f33b.png";